import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import LatestPayments from "components/admin/payments/LatestPayments";
import { Stack } from "components/layout/reusableLayouts";

interface ContactRecentPaymentsCardProps {
  contactId: string;
}

/** Payments made to this contact, which the server matches on the payee alone. */
const ContactRecentPaymentsCard: React.FC<ContactRecentPaymentsCardProps> = ({
  contactId,
}) => {
  const { t } = useTranslation();

  return (
    <Card variant="outlined" sx={{ padding: "var(--space-6)" }}>
      <Stack gap="var(--space-5)">
        <Typography variant="h5">{t("Recently Paid")}</Typography>
        <LatestPayments
          contactId={contactId}
          emptyState={
            <Typography
              variant="body2"
              sx={{
                color: "var(--color-text-tertiary)",
                textAlign: "center",
                paddingBlock: "var(--space-6)",
                border: "1px dashed var(--color-border-subtle)",
                borderRadius: "var(--radius-md)",
              }}
            >
              {t("No recent payments found")}
            </Typography>
          }
        />
      </Stack>
    </Card>
  );
};

export default ContactRecentPaymentsCard;
